import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { UnitTypeEnum } from '../../../models/unit-type-enum';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-land-price-comparable-chart',
  templateUrl: './land-price-comparable-chart.component.html',
  styleUrls: ['./land-price-comparable-chart.component.scss']
})
export class LandPriceComparableChartComponent {
  @Input() Property_Uid: string = '';
  @Input() type: string='';
  @Input() chartTitle: any = '';
  @Input() SectionId: string = '';

  @Input() ApiEndPoint = '';
  @Input() neigh_name='';
  @Input() project_name='';
  @Output() isEmpatyCheck = new EventEmitter();
  graphData: any;

  UnitTypes: any = [];
  GradesDropdown: any = null;
  warehouseDropdown: any = null;
  UnitSizeDropdown: any = null;
  NeighList: any = [];

  chartView = ReportsChartEnum;
  priceChartData: any = [];
  selectedChartId: string = '';
  chartId = 'abc'; 
  trendsData: any;
  trendsText: string = '';
  minDateOnwards: any;

selected_unit_size: string[] = []; 
filter: any = { "unit_sub_type": "","property_grade": "", "neigh_name": "","unit_size": [],"unit_main_category": ""};
  // filter: any = { "unit_sub_type": "", "property_grade": "", "neigh_name": "", "unit_size": "", "unit_main_category": "" };
  selected_unit_type:string[]=[];
  selected_neigh:string[]=[];
  selected_property_grade:string = '';
  // selected_unit_size: string = '';
  selected_unit_main_category: string = '';

  currentLang: string = '';
  languageSub$: Subscription = new Subscription();
  neighNname:string='';
  chartLoader!: boolean;

  isFirstload=true;
  constructor(
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private translate: TranslateService,
    private commonPropertyService: CommonPropertyDetailPageService
  ) {
      this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
       this.updateNeighList();
    })
  }

ngOnChanges(changes: SimpleChanges) {
    this.updateNeighList();
    this.chartId = this.SectionId;   
    this.getApartmentData();
}

ngOnInit() {   
    
}

updateNeighList(){
    this.NeighList = this.sharedService.getStoreValue(GlobalContants.StoreKey.neighList);
    this.NeighList.forEach((e: any) => {
      const nameEn = e.neigh_name?.["1"];
      const nameAr = e.neigh_name?.["2"]?.trim() || nameEn;

      e.name = nameEn;
      e.label = { 1: nameEn, 2: nameAr };
    });
    this.neighNname = this.sharedService.getNeighLabel(this.neigh_name);
    
}

getApartmentData(){
  
  //check the null value in json
  if(this.selected_unit_type?.length) this.filter['property_subcat']= this.selected_unit_type;
  if(this.selected_property_grade) this.filter['property_grade']=this.selected_property_grade;
  if(this.selected_neigh?.length) this.filter['neigh_name']=this.selected_neigh;
  // if(this.selected_unit_size?.length) this.filter['unit_size'] =this.selected_unit_size;
if (this.selected_unit_size?.length > 0) {
  this.filter['unit_size'] = this.selected_unit_size;
} else {
  delete this.filter['unit_size']; 
}

  if(this.selected_unit_main_category?.length) this.filter['unit_main_category'] = this.selected_unit_main_category;

  const filterdata = Object.entries(this.filter).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {} as Record<string, any>);
  
  let params = Object.keys(filterdata).length === 0 ? null : JSON.stringify(filterdata).replace(/[+]/g, '%2B');
  if(params) {
    params = encodeURIComponent(params)
  };
  this.chartLoader=true;
   this.commonPropertyService.getApartmentPriceAnalysis(this.ApiEndPoint,this.Property_Uid, this.type, `${params}`).subscribe(
    {
      next:(res:any)=>{
         this.chartLoader=false;
         if (res.status == 200) {
           this.graphData = res.data;
          
           if (!this.selected_property_grade) {
             if (this.graphData?.grade && this.graphData?.grade.length) {
              this.createGradeDropdown(this.graphData?.grade, this.graphData?.default_grade);
              let grade_v=  this.graphData?.grade.find((g: any) => this.graphData?.default_grade == (g.name))
              this.selected_property_grade = grade_v ? grade_v.label[1] : ''
             }
            
           }
 
            if (!this.selected_unit_size?.length) {
              if (this.graphData?.unit_size_range && this.graphData?.unit_size_range.length) {
                this.createUnitsizeDropdown(this.graphData?.unit_size_range, this.graphData?.default_unit_size);
              }
              this.selected_unit_size = this.graphData?.default_unit_size 
                ? [this.graphData?.default_unit_size]
                : [];
            }
          //  if (!this.selected_unit_size) {
          //    if (this.graphData?.unit_size_range && this.graphData?.unit_size_range.length) {
          //      this.createUnitsizeDropdown(this.graphData?.unit_size_range, this.graphData?.default_unit_size);
          //    }
          //    this.selected_unit_size = this.graphData?.default_unit_size
          //  }
           if (this.selected_unit_type.length == 0 && this.graphData?.default_unit_sub_types) {
             this.UnitTypes = this.graphData?.unit_sub_types ? this.sortUnintType(this.graphData.unit_sub_types):'';
            let default_units = this.graphData?.default_unit_sub_types.includes(',') ? this.graphData?.default_unit_sub_types.split(',') : [this.graphData?.default_unit_sub_types];
             this.selected_unit_type =  this.UnitTypes
                .filter((unit: any) => default_units.includes(unit.name))
                .map((unit: any) => unit.label[1]);
              }
          
           if (!this.selected_unit_main_category) {
             if (this.graphData?.warehouse_types && this.graphData?.default_warehouse_types) {
               let sortwarehouseData = this.sortwarehouseType(this.graphData?.warehouse_types);
               this.createWarehouseDropdown(sortwarehouseData, this.graphData?.default_warehouse_types)
               let ware = sortwarehouseData.find((unit: any) => this.graphData?.default_warehouse_types == (unit.name))
               this.selected_unit_main_category = ware ?  ware.label[1] : '';
             }             
           }

           if (this.selected_neigh.length == 0 && this.graphData?.default_neighborhood) {
             this.selected_neigh = [this.sharedService.getNeighLabel(this.graphData?.default_neighborhood)];
           }

           this.createChartData();
            this.updateSection();
         } else {
           this.graphData = null;
           this.createChartData();
           this.updateSection();
         }
       }, error: (err) => {
         this.chartLoader=false;
         this.graphData = null;
         this.createChartData();
        this.updateSection();
       }
    }
  )
}

sortUnintType(unit_types: any) {
  const sortOrder = ['standalone_commercial', 'F_B_Plaza', 'Retail_Mall', 'Retail_Plaza'];
  const hasWarehouseUnits = unit_types.some((unit: any) => sortOrder.includes(unit.name));
  if(hasWarehouseUnits) {
    return unit_types.sort((a: any, b: any) => {
      return sortOrder.indexOf(a.name) - sortOrder.indexOf(b.name);
    });
  } else {
    return [...unit_types].sort((a, b) => a.name.localeCompare(b.name));
  }
}

sortwarehouseType(unit_types: any) {
  const sortOrder = ['dry_warehouse', 'ambient', 'cold_storage', 'frozen_warehouse'];
  const hasWarehouseUnits = unit_types.some((unit: any) => sortOrder.includes(unit.name));
  if(hasWarehouseUnits) {
    return unit_types.sort((a: any, b: any) => {
      return sortOrder.indexOf(a.name) - sortOrder.indexOf(b.name);
    });
  } else {
    return [...unit_types].sort((a, b) => a.name.localeCompare(b.name));
  }
}
  createWarehouseDropdown(warehouse:any, default_type:string){
    this.warehouseDropdown = {
        label: 'reports.pleaseSelectUnitType',
        data: warehouse.map((key: any) => ({
          value: key.label,
          id: key.name,
        })),
        default: (!this.selected_unit_main_category) ? default_type : this.selected_unit_main_category,
        maxSelect: 1,
        reportType: false,
      };
  }
  createGradeDropdown(grades: any, default_grade: string) {
    const sorted_grades = this.sharedService.gradeSortJSonArray(grades);
    
    this.GradesDropdown = {
      label: 'reports.please_select_grade',
      data: sorted_grades.map((key: any) => ({
        value: key.label,
        id: key.name,
      })),
      default: (!this.selected_property_grade) ? default_grade : this.selected_property_grade,
      maxSelect: 1,
      reportType: false,
    };
  }
  // createUnitsizeDropdown(unit_sizes: any, default_value: string) {
  //   this.UnitSizeDropdown = {
  //     label: 'reports.pleaseSelectUnitSize',
  //     data: unit_sizes.map((key: string) => ({
  //       value: key,
  //       id: key,
  //     })),
  //     default: (!this.selected_unit_size) ? default_value : this.selected_unit_size,
  //     maxSelect: 1,
  //     reportType: false,
  //   };
  // }
createUnitsizeDropdown(unit_sizes: any, default_value: string | null) {
  if (!unit_sizes?.length) {
    this.UnitSizeDropdown = null;
    return;
  }
  const dropdownData = unit_sizes.map((key: string) => ({
    name: key, 
    label: { 1: key, 2: key }  
  }));
  this.UnitSizeDropdown = dropdownData;
  this.selected_unit_size = default_value && unit_sizes.includes(default_value)
    ? [default_value] 
    : [];
}
createChartData() {
  const obj = this.graphData;
  if (obj && !obj?.quarterly_rates) {
    this.priceChartData = [];
    return;
  }
  let rawData = obj?.quarterly_rates || [];
  this.priceChartData = this.cleanAndFillData(rawData);
  
}

  cleanAndFillData(data: any[]) {
    if (!data?.length) return [];
    const parseQuarter = (q: any) => {
      const [quarter, year] = q.split("-");
      return { year: +year, quarter: +quarter.replace("Q", "") };
    };

    // Step 1: Sort by year + quarter
    const sorted = [...data].sort((a, b) => {
      const A = parseQuarter(a.quarter);
      const B = parseQuarter(b.quarter);
      return A.year - B.year || A.quarter - B.quarter;
    });

    // Step 2: Find first and last quarters
    const quarters = sorted.map(d => parseQuarter(d.quarter));
    const minYear = Math.min(...quarters.map(q => q.year));
    const maxYear = Math.max(...quarters.map(q => q.year));
    const lastQuarter = quarters[quarters.length - 1];

    // Step 3: Generate quarters up to the last one in data
    const allQuarters = [];
    for (let y = minYear; y <= maxYear; y++) {
      for (let q = 1; q <= 4; q++) {
        if (y === lastQuarter.year && q > lastQuarter.quarter) break;
        allQuarters.push(`Q${q}-${y}`);
      }
    }

    // Step 4: Merge existing + missing
    const map = new Map(sorted.map(d => [d.quarter, d]));
    const filled = allQuarters.map(q => map.get(q) || { quarter: q, subject: null, comparable: null });

    // Step 5: Carry forward values
    let lastSubject: any = null;
    let lastComparable: any = null;
    const carried = filled.map(d => {
      if (d.subject !== null) lastSubject = d.subject;
      if (d.comparable !== null) lastComparable = d.comparable;
      return {
        quarter: d.quarter,
        subject: d.subject ?? lastSubject,
        comparable: d.comparable ?? lastComparable
      };
    });

    // Step 6: Skip before first valid subject
    const firstValidIndex = carried.findIndex(d => d.subject !== null);
    return firstValidIndex === -1 ? [] : carried.slice(firstValidIndex);
  }


  getSymbolByType(type: UnitTypeEnum): string {
    let symbol = '';

    if (type === UnitTypeEnum.currencywithsqm) {
      symbol = ` ${this.translate.instant(
        this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
      )}/${this.translate.instant(
        GlobalContants.keySymbolContants.squareMeterUnit
      )}`;
    }

    if (type === UnitTypeEnum.currency) {
      symbol = ` ${this.translate.instant(
        this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
      )}`;
    }

    if (type === UnitTypeEnum.percentage) {
      symbol = GlobalContants.keySymbolContants.percentage;
    }
    return symbol;
  }


  trendsdropDownChange(event: any, type:string) {    
    if(type == 'unit_type'){
       this.selected_unit_type = event;     
    }else if(type == 'grade'){
      this.selected_property_grade=event;
    }else if(type == 'neigh_name'){
        this.selected_neigh = event
    }else if(type == 'unit_size'){
        this.selected_unit_size = event
    }else if(type == 'warehouse'){
       this.selected_unit_main_category = event
    }
    if(this.isFirstload){
      this.isFirstload =false;
    }
    this.getApartmentData();
  }


  updateSection(){
    if (this.isFirstload) {
      if (this.graphData?.quarterly_rates?.length) {
      } else { this.isEmpatyCheck.emit(true); }
    }
  }
   
isAllComparableNull(data:any) {
  return data.every((item:any) => item.comparable === null);
}
}
